import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import React, { useEffect, useState } from "react";
import Details from "./Details";
import Chart from "./Chart";
import Table from "shared/Table";
import { TRANSACTIONTABLECOLUMN } from "utilities/data";
import NGOdetails from "./components/NGOdetails";
import NGOAccount from "./components/NGOAccount";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllActiveProject,
  getAllCompletedProjects,
  getProjects,
} from "appState/project/projectSlice";
import { getCurrentNgoProfile } from "appState/auth/authSlice";
import {
  getDonationCountPerNGO,
  getDonationPerNgo,
  totalDonationAmountPerNgo,
} from "appState/donation/donationSlice";
import { getNgoTransactions } from "appState/transaction/transactionSlice";
import { TKIconSpinner } from "assets/images/svgs";

const NGODashboardContents = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [body, setBody] = useState({});

  const { ngoProfile } = useSelector((state) => state.auth);
  const { transactions, transactionsCount, isLoading } = useSelector(
    (state) => state.transaction
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjects());
    dispatch(getCurrentNgoProfile());
    ngoProfile?.ngoProfile?.ngo?._id &&
      dispatch(getDonationPerNgo({ id: ngoProfile?.ngoProfile?.ngo?._id }));
    dispatch(totalDonationAmountPerNgo({ ngoId: ngoProfile?.ngoProfile?._id }));
    dispatch(getAllActiveProject());
    dispatch(getDonationCountPerNGO());
    dispatch(getAllCompletedProjects());
    dispatch(getNgoTransactions());
  }, [dispatch, ngoProfile?.ngoProfile?._id, ngoProfile?.ngoProfile?.ngo?._id]);

  const navigate = useNavigate();

  const handleNextStep = () => {
    if (currentStep === 0) {
      return setCurrentStep((prev) => prev + 1);
    } else if (currentStep === 1) {
      return setCurrentStep((prev) => prev + 1);
    }
  };

  const steps = [
    <NGOdetails setBody={setBody} next={handleNextStep} />,
    <NGOAccount body={body} />,
  ];

  const handleTransactionNavigate = () => {
    let path = "/ngo/transactions";
    navigate(path);
  };

  return (
    <div>
      {ngoProfile === undefined && (
        <div className="flex">
          <div
            className={
              "absolute h-screen max-[600px]:w-[80%] w-2/5 bg-white top-0 right-0 z-[99999999] overflow-y-auto"
            }
          >
            {steps[currentStep]}
          </div>
          <div className="fixed inset-0 bg-black opacity-40 z-10"></div>
        </div>
      )}
      <NGODashboardLayout infoText="Here is a brief Summary">
        <div className="flex flex-col gap-6">
          <div className="flex max-[900px]:flex-col gap-6">
            <div className="w-[70%] max-[900px]:w-full">
              <Details />
            </div>
            <div className="w-[30%] h-[506px] max-[900px]:w-full">
              <Chart />
            </div>
          </div>
          <div className="bg-white flex flex-col justify-center rounded-md p-3">
            {isLoading ? (
              <TKIconSpinner />
            ) : (
              <>
                <div className="flex justify-between items-center gap-4">
                  <p className="flex justify-start my-2 font-semibold text-[16px]">
                    Recent Transactions
                  </p>
                  {transactionsCount > 0 && (
                    <p
                      onClick={handleTransactionNavigate}
                      className="text-[#F57200] text-[14px] cursor-pointer underline transition-all duration-300 hover:text-[15px]"
                    >
                      View all
                    </p>
                  )}
                </div>
                <Table
                  columns={TRANSACTIONTABLECOLUMN}
                  data={transactions?.slice(0, 6)}
                  selectableRows
                  pointer
                />
              </>
            )}
          </div>
        </div>
      </NGODashboardLayout>
    </div>
  );
};

export default NGODashboardContents;
